export class ClaudeEnterpriseKeyOrganization {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "userCount",
            "baseName": "userCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "userCountIsLowerBound",
            "baseName": "userCountIsLowerBound",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ClaudeEnterpriseKeyOrganization.attributeTypeMap;
    }
    constructor() {
    }
}
